import { render, staticRenderFns } from "./Daycounter.vue?vue&type=template&id=4afd2d54&scoped=true&"
import script from "./Daycounter.vue?vue&type=script&lang=js&"
export * from "./Daycounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd2d54",
  null
  
)

export default component.exports